import { ReactNode, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { globalStore } from "../utils/globalStore";
import { InitService } from "../utils/initService";
import { UserRoleManager } from "../utils/userRole";
import type { UserInfo } from "../types";

/**
 * 登录守卫：无 token 跳转登录。
 * 已登录时拉齐菜单/用户信息（原由旧版顶栏 NavBar 触发；工作台壳内由 HomeShell 也会触发，InitService 会去重）。
 */
const Auth = ({ children }: { children: ReactNode }) => {
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!token) return;
    const storedUserInfo = globalStore.getUserInfo();
    const permissions = storedUserInfo?.permissions || [];
    const needInit =
      !InitService.isInitialized() || !storedUserInfo || permissions.length === 0;
    if (!needInit) return;

    let cancelled = false;
    void InitService.initializeUserData()
      .then(() => {
        if (cancelled) return;
        const next = globalStore.getUserInfo();
        if (next) {
          UserRoleManager.updateUserRoleInfo(next as UserInfo);
        }
      })
      .catch((error) => {
        console.error("Auth: 初始化用户数据失败:", error);
      });
    return () => {
      cancelled = true;
    };
  }, [token]);

  if (!token) {
    return <Navigate to="/login" />;
  }

  return <>{children}</>;
};

export default Auth;
